export const STATICS_DIR = '/static/';
export const SUBSCRIPTION_TYPES = {
  individual: 'Individual',
  organization: 'Organization',
  partner: 'Partner',
};

export const IS_APP = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('isApp') === 'true';
};

export const IS_IOS = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('isIOS') === 'true';
};

export const IS_SHARED_VIEW = () => {
  const url = new URL(window.location);
  return url.pathname === '/s';
};

const mobileByUserAgent = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
export const deviceHasTouchFunc =
  'ontouchstart' in window || navigator.maxTouchPoints > 0;
export function IS_MOBILE() {
  return (
    window.innerWidth <= 768 ||
    IS_APP() ||
    (deviceHasTouchFunc && mobileByUserAgent())
  );
}
export const WINDOW_WIDTH = () => window.innerWidth;
export const SIDEBAR_WIDTH = window.innerWidth / 3; //As per request, this has been changed to half the size of the viewport width.
export const NAVBAR_WIDTH = () => (IS_MOBILE() ? 60 : 50);

export const TOOLBAR_WIDTH_VERT = 0;
export const TOOLBAR_HEIGHT_HOR = undefined; // WIP

export const VIDEO_FILE_TYPES = ['mp4', 'mov', 'webm', 'avi', 'mkv'];

export const STATUS_COLOR_MAP = {
  0: '#007BFF', //backlog
  1: '#FFA500', //progress
  2: '#6F42C1', //review
  3: '#28A745', //completed
  4: '#6C757D', //dropped
};

export const OHIVE_COLORS = {
  primary: 'var(--o-hive-primary-100)',
  secondary: 'var(--o-hive-secondary-100)',
  light: 'var(--o-hive-light-100)',
  dark: 'var(--o-hive-dark-100)',
  error: 'var(--o-hive-error-100)',
  success: 'var(--o-hive-success-100)',
  warning: 'var(--o-hive-warning-100)',
};

export const acceptedFormats = {
  images: '.jpg, .jpeg, .png, .gif, .bmp, .webp',
  models: '.gltf, .glb, .obj, .stl, .step, .STEP, .stp',
};

export const MODIFIABLE_EXTENSIONS = ['.glb', '.gltf', '.stl'];

export const FULL_SCREEN_PREVIEW_PAGES = ['/', '/projects'];
